if (!customElements.get('swatch-collapse')) {
  customElements.define(
    'swatch-collapse',
    class SwatchCollapse extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-swatch-collapse-toggle]');
        this.countTarget = this.querySelector('[data-swatch-collapse-count]');
        this.moreTextTarget = this.querySelector('[data-swatch-collapse-more-text]');
        if (!this.button) return;

        this.expanded = false;
        this.lastWidth = 0;
        this.button.addEventListener('click', this.toggle.bind(this));

        // Track width only: our own show/hide changes the wrapper height and
        // would retrigger the observer into an endless collapse loop.
        this.resizeObserver = new ResizeObserver((entries) => {
          const width = Math.round(entries[0].contentRect.width);
          if (width === this.lastWidth) return;
          this.lastWidth = width;
          if (!this.expanded) this.collapse();
        });
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      get inputs() {
        return Array.from(this.querySelectorAll('input[type="radio"]'));
      }

      labelFor(input) {
        return input.nextElementSibling;
      }

      toggle() {
        this.expanded = !this.expanded;
        this.button.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
        this.classList.toggle('swatch-collapse--expanded', this.expanded);

        if (this.expanded) {
          const firstHidden = this.inputs.find((input) => input.hidden);
          this.inputs.forEach((input) => (input.hidden = false));
          firstHidden?.focus();
        } else {
          this.collapse();
        }
      }

      collapse() {
        const inputs = this.inputs;
        if (!inputs.length) return;

        inputs.forEach((input) => (input.hidden = false));
        this.button.hidden = true;

        const labels = inputs.map((input) => this.labelFor(input)).filter(Boolean);
        if (!labels.length) return;

        // Geometric constant of the first row: tiles are equal height, so any
        // tile sitting on row one shares this offsetTop.
        const rowTop = labels[0].offsetTop;

        if (labels[labels.length - 1].offsetTop === rowTop) return;

        this.button.hidden = false;

        // The selected value must never disappear into the overflow.
        const checked = inputs.find((input) => input.checked);

        inputs.forEach((input) => {
          const label = this.labelFor(input);
          if (input !== checked && label && label.offsetTop > rowTop) input.hidden = true;
        });

        // The toggle sits after the tiles, so it can still be pushed to row
        // two by an exactly-full first row — trade trailing tiles for it.
        let guard = inputs.length;
        while (this.button.offsetTop > rowTop && guard-- > 0) {
          const visible = inputs.filter((input) => !input.hidden && input !== checked);
          const last = visible[visible.length - 1];
          if (!last) break;
          last.hidden = true;
        }

        const hiddenCount = inputs.filter((input) => input.hidden).length;
        if (hiddenCount === 0 || this.button.offsetTop > rowTop) {
          inputs.forEach((input) => (input.hidden = false));
          this.button.hidden = true;
          return;
        }

        if (this.countTarget) this.countTarget.textContent = hiddenCount;
        if (this.moreTextTarget) {
          const template = hiddenCount === 1 ? this.dataset.textMoreOne : this.dataset.textMoreOther;
          if (template) this.moreTextTarget.textContent = template.replace('[count]', hiddenCount);
        }
      }
    }
  );
}
